module.exports = __webpack_public_path__ + "img/img-10.85a19433.png";